export default {"src":"/newStatic/_next/static/media/ticket.326f2218.svg","height":40,"width":53};